import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import JSONbig from 'json-bigint';
import {
  barbersLimitedReservationApiUrl,
  adminPassword,
  adminUsername,
} from '../../config';
import { RecommendedPartner } from '../../types/partner';

const response = [
  (data: any) => {
    if (typeof data === 'string') {
      try {
        data = JSONbig.parse(data);
      } catch (e) {
        console.error(e);
      }
    }
    return data;
  },
];

export const getRecommendedPartners = async (): Promise<
  AxiosResponse<RecommendedPartner[]>
> => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `${barbersLimitedReservationApiUrl}/partners/recommended`,
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error fetching recommended partners:', error);
    throw error;
  }
};

export const getShopSlotsById = async (
  shopId: bigint
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `${barbersLimitedReservationApiUrl}/shop-slots/shop/${shopId}`,
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error fetching shop slots:', error);
    throw error;
  }
};

export const getShopSlotsByShopIdAndBarberId = async (
  shopId: bigint,
  barberId: bigint
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `${barbersLimitedReservationApiUrl}/shop-slots/search`,
    params: {
      shopId: shopId.toString(),
      barberId: barberId.toString(),
    },
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error fetching shop slots by shop and barber:', error);
    throw error;
  }
};

export const getBarberSlotsByBarberId = async (
  barberId: bigint
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `${barbersLimitedReservationApiUrl}/barber-slots/barber/${barberId}`,
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error fetching barber slots by barberId:', error);
    throw error;
  }
};

export const getBookingsByBarberId = async (
  barberId: bigint
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `${barbersLimitedReservationApiUrl}/bookings/barber/${barberId}`,
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error fetching bookings by barber ID:', error);
    throw error;
  }
};

export const getBookingsByShopId = async (
  shopId: bigint
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `${barbersLimitedReservationApiUrl}/bookings/shop/${shopId}`,
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error fetching bookings by shop ID:', error);
    throw error;
  }
};

export const getBookingById = async (
  bookingId: string
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `${barbersLimitedReservationApiUrl}/bookings/${bookingId}`,
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error fetching booking by ID:', error);
    throw error;
  }
};

export const getShopTotalBookingCount = async (
  shopId: bigint
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `${barbersLimitedReservationApiUrl}/shops/${shopId}/bookings/count`,
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error fetching confirmed booking count for shop:', error);
    throw error;
  }
};

export const getBarberTotalBookingCount = async (
  barberId: bigint
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `${barbersLimitedReservationApiUrl}/barbers/${barberId}/bookings/count`,
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error fetching confirmed booking count for barber:', error);
    throw error;
  }
};
